<div
    class="datiq-cell-header-sort bg-white"
    [attr.data-testid]="settings.id"
    [ngClass]="{ 'datiq-cell-header-sort--visualization': typeIsVisualization, 'flex-row-reverse': settings?.align === 'right' }"
>
    <button
        [disabled]="settings?.disabled"
        (click)="toggle()"
        mat-button
        [attr.data-testid]="settings.id + '-button'"
        class="datiq-cell-header-sort__button bg-white !h-[38px]"
        [disableRipple]="true"
    >
        <div
            class="datiq-cell-header-sort__container datiq-cell-header-sort__container--label"
        >
            <span
                class="datiq-cell-header-sort__label font-caption text-dat-grey-500"
                [attr.data-testid]="settings.id + '-label'"
                [ngClass]="{
                    'datiq-cell-header-sort__label--visualization':
                        typeIsVisualization
                }"
            >
                {{ settings?.label }}
            </span>
        </div>
        <div
            class="datiq-cell-header-sort__container datiq-cell-header-sort__container--icon"
            [attr.data-testid]="settings.id + '-icon'"
        >
            <mat-icon
                class="datiq-cell-header-sort__icon"
                [svgIcon]="settings?.sortBy"
            ></mat-icon>
        </div>
    </button>
</div>
